import { __read, __spreadArray, __assign } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useCallback } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import clsx from 'clsx';
import { Toast } from '../Toast.js';
import { ToastContext, ToastStateContext } from './ToastContext.js';
import styles from './ToastContext.module.scss.js';

var createId = function () { return Math.random().toString(36).slice(2, 11); };
var DEFAULT_TIMEOUT = 5000;
var ToastContextController = function (_a) {
    var children = _a.children;
    var _b = __read(useState([]), 2), toasts = _b[0], setToasts = _b[1];
    var removeToast = useCallback(function (toastToRemoveId) {
        setToasts(function (oldToasts) { return oldToasts.filter(function (_a) {
            var id = _a.id;
            return id !== toastToRemoveId;
        }); });
    }, []);
    var addToast = useCallback(function (newToast) {
        var id = createId();
        setToasts(function (currentToasts) { return __spreadArray(__spreadArray([], __read(currentToasts), false), [__assign(__assign({}, newToast), { id: id })], false); });
        if (newToast.withTimeout !== false) {
            setTimeout(function () {
                removeToast(id);
            }, newToast.timeout || DEFAULT_TIMEOUT);
        }
    }, [removeToast]);
    var toastWrapper = function (_a) {
        var toastItems = _a.toastItems, position = _a.position;
        return (jsx("div", __assign({ className: clsx(styles.toastWrapper, position === 'top' && styles.toastWrapperTop), "data-testid": "toasts-wrapper" }, { children: jsx(TransitionGroup, { children: toastItems.map(function (toast) { return (jsx(CSSTransition, __assign({ timeout: 300, classNames: {
                        enter: styles.toastEnter,
                        enterActive: styles.toastEnterActive,
                        exit: styles.toastExit,
                        exitActive: styles.toastExitActive,
                    } }, { children: jsx(Toast, __assign({}, toast, { onClose: function () { return (toast.onActionClick ? toast.onActionClick() : removeToast(toast.id)); } })) }), toast.id)); }) }) })));
    };
    return (jsxs(ToastContext.Provider, __assign({ value: { addToast: addToast, removeToast: removeToast } }, { children: [jsx(ToastStateContext.Provider, __assign({ value: { toasts: toasts } }, { children: children })), toastWrapper({ toastItems: toasts.filter(function (toast) { return toast.position === 'top'; }), position: 'top' }), toastWrapper({
                toastItems: toasts.filter(function (toast) { return toast.position === undefined || toast.position === 'bottom'; }),
                position: 'bottom',
            })] })));
};

export { ToastContextController };
